<template>
  <div class="profileStats">
    <facebook-login v-if="hasFb()"
                    :enteredUsername="userDetails.username"
                    :previousComponentFacebook="profilePage">
    </facebook-login>
<!--    <div class="profile_stars_container">-->
<!--      <div class="profile_stars_inside">-->
<!--        <div class="stars_icon"><img src="/static/images/star.svg" alt="" class=""></div>-->
<!--        <div class="stars_count"><p>{{ numberFormatting(userDetails.totalPointsEarned) }}</p></div>-->
<!--      </div>-->
<!--      <div class="profile_stars_info">-->
<!--        <p>$#Stars can be exchanged for Nojoom Points! Check it out here</p>-->
<!--      </div>-->

<!--    </div>-->
      <div class="profile_stats_container" v-if="addOnMode.text !== 'HIDE'">
        <h1>{{ getTranslations.home_profile_profile_stats_your_status }}</h1>
        <div class="profile_stats_row">
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_game_unlocked }}</label>
            <p>{{ numberFormatting(userDetails.availableGames) }}</p>
          </div>
          <div class="vertical_line_home"></div>
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_games }}</label>
            <p>{{ numberFormatting(userDetails.gamesPlayed) }}</p>
          </div>
          <div class="vertical_line_home"></div>
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_points }}</label>
            <p>{{ numberFormatting(userDetails.totalPointsEarned) }}</p>
          </div>
        </div>
        <div class="profile_stats_row">
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_penalty_goals }}</label>
            <p>{{ numberFormatting(userDetails.penaltyScored) }}</p>
          </div>
          <div class="vertical_line_home"></div>
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_penalty_shots }}</label>
            <p>{{ numberFormatting(userDetails.penaltyNo) }}</p>
          </div>
          <div class="vertical_line_home"></div>
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_achievements }}</label>
            <p>{{ numberFormatting(userDetails.achievements) }}</p>
          </div>
        </div>
      </div>

      <div class="profile_stats_container" v-else>
        <h1>{{ getTranslations.home_profile_profile_stats_your_status }}</h1>
        <div class="profile_stats_row">
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_game_unlocked }}</label>
            <p>{{ numberFormatting(userDetails.availableGames) }}</p>
          </div>
          <div class="vertical_line_home"></div>
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_games }}</label>
            <p>{{ numberFormatting(userDetails.gamesPlayed) }}</p>
          </div>
        </div>

        <div class="profile_stats_row">
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_points }}</label>
            <p>{{ numberFormatting(userDetails.totalPointsEarned) }}</p>
          </div>
          <div class="vertical_line_home"></div>
          <div class="home_stats">
            <label>{{ getTranslations.home_profile_profile_achievements }}</label>
            <p>{{ numberFormatting(userDetails.achievements) }}</p>
          </div>
        </div>
      </div>


  </div>
</template>

<script>
import FacebookLogin from '@/components/visitor/FacebookLogin';
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';

export default {
  name: 'profile-stats',
  mixins: [NumbersFormattingMixin],
  components: {
    FacebookLogin,
  },
  data() {
    return {
      profilePage: 'profile',
    };
  },
  methods: {
    hasFb() {
      return this.$route.path === '/home/profile' && !this.userDetails.facebookId && this.facebookFunctionality;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'facebookFunctionality',
      'addOnMode',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileStats.vue